import { createContext } from "react";

const FileContext = createContext();

export default FileContext;
